/**
 * The 10 core Deelname figures (PLAN-FASE2.md § WP-03): the six funnel
 * steps' order and i18n keys, and the four engagement rates'. Pure config,
 * shared by `ParticipationPage`/`FunnelCard`/`RateCard` and their tests.
 */

import type { FunnelStepKey } from '@/features/participation/api';

export const FUNNEL_STEP_ORDER: readonly FunnelStepKey[] = [
  'invited',
  'activated',
  'active_7d',
  'active_30d',
  'structurally_active',
  'needs_reactivation',
];

export type RateKey =
  | 'daily_sync_pct'
  | 'ai_coach_use_pct'
  | 'challenge_participation_pct'
  | 'notification_open_pct'
  | 'break_adoption_pct'
  | 'focus_rhythm_pct';

export const RATE_KEYS: readonly RateKey[] = [
  'daily_sync_pct',
  'ai_coach_use_pct',
  'challenge_participation_pct',
  'notification_open_pct',
  'break_adoption_pct',
  'focus_rhythm_pct',
];
